import { defineComponent, reactive  } from 'vue';

export const ProductTutorialVideosApplication =  defineComponent({
    name: 'ProductTutorialVideosApplication',
    components: {
        
    },
    setup() {
        const videos = reactive([
            {
                title: 'Overview of the Guru Mode',
                description: 'Learn a little about Snappii and how to use the Guru Mode editor.',
                youtubeUrl: 'https://www.youtube.com/watch?v=g2GtoBV3748',
                youtubeVideoId: 'g2GtoBV3748'
            },
            {
                title: 'How to create ODBC connector',
                description: 'Learn how to set up ODBC connector to connect to your database.',
                youtubeUrl: 'https://www.youtube.com/watch?v=EGRNSWnDWSk',
                youtubeVideoId: 'EGRNSWnDWSk'
            },
            {
                title: 'How to use Table selection',
                description: 'Learn how to use the Table element of the Guru mode.',
                youtubeUrl: 'https://www.youtube.com/watch?v=21C2H-Dvp64',
                youtubeVideoId: '21C2H-Dvp64'
            },
            {
                title: 'How to Create Conditional Forms',
                description: 'Learn how to make a form based on a user\'s reply.',
                youtubeUrl: 'https://www.youtube.com/watch?v=95VPIr5cVxQ',
                youtubeVideoId: '95VPIr5cVxQ'
            },
            {
                title: 'Adding a calendar',
                description: 'Learn how to set up a calendar.',
                youtubeUrl: 'https://www.youtube.com/watch?v=zrPcCFEJpfc',
                youtubeVideoId: 'zrPcCFEJpfc'
            },
            {
                title: 'How to create a database',
                description: 'Learn how to make a database with the Snappii app builder.',
                youtubeUrl: 'https://www.youtube.com/watch?v=RY81wUoJ9zA',
                youtubeVideoId: 'RY81wUoJ9zA'
            },
        ]);

        return () => (
            <div class="product-tutorial-videos__layout">
                <div class="product-tutorial-videos__content-layout">
                    <div class="product-tutorial-videos__heading-2-container">
                        <h2 class="product-tutorial-videos__heading-2">Product tutorial videos</h2>
                    </div>
                    <div class="product-tutorial-videos__videos-container">
                        <div class="product-tutorial-videos__videos">
                            <ul class="product-tutorial-videos__videos-list">
                                {videos.map(({ title, description, youtubeVideoId }) => {
                                    return <li class="product-tutorial-videos__videos-item" key={title}>
                                        <div class="product-tutorial-videos__video product-tutorial-videos-video">
                                            <div class="product-tutorial-videos-video__video-player-container">
                                                <iframe
                                                    class="product-tutorial-videos-video__video-player lazyload"
                                                    frameborder="0"
                                                    width="100%"
                                                    height="100%"
                                                    title="Creating mobile forms with Snappii app builder"
                                                    allowfullscreen
                                                    data-src={`//www.youtube.com/embed/${youtubeVideoId}`}>
                                                </iframe>
                                            </div>
                                            <div class="product-tutorial-videos-video__title-container">
                                                <p class="product-tutorial-videos-video__title">{title}</p>
                                            </div>
                                            <div class="product-tutorial-videos-video__description-container">
                                                <p class="product-tutorial-videos-video__description">{description}</p>
                                            </div>
                                        </div>
                                    </li>
                                })}                       
                            </ul>
                        </div>
                    </div>
                </div>
       
            </div>
        )
    }
});

export type ProductTutorialVideosApplication = InstanceType<typeof ProductTutorialVideosApplication>
